import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentMapperService {
  constructor(private http: HttpClient) { }


  get<T>(endpoint: string, params?: any): Observable<T> {
    const url = params ? `${environment.apiBaseUrl}/${endpoint}${params}` : `${environment.apiBaseUrl}/${endpoint}`
    return this.http.get<T>(url);
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    const url = `${environment.apiBaseUrl}/${endpoint}`;
    return this.http.post<T>(url, body);
  }

  put<T>(endpoint: string, body: any,): Observable<T> {
    const url = `${environment.apiBaseUrl}/${endpoint}`;
    return this.http.put<T>(url, body);
  }

  patch<T>(endpoint: string, body: any,): Observable<T> {
    const url = `${environment.apiBaseUrl}/${endpoint}`;
    return this.http.patch<T>(url, body);
  }



  delete<T>(endpoint: string): Observable<T> {
    const url = `${environment.apiBaseUrl}/${endpoint}`;
    return this.http.delete<T>(url);
  }
  
}
